import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is Scythe Products?",
    a: "Scythe Products is a digital software bundle of game-specific AI vision models for real-time on-screen image analysis, together with related software tools.",
  },
  {
    q: "What do the models do?",
    a: "Each model is built for a particular game. It analyzes visual information on screen, recognizes the objects it was trained on, and marks them in real time.",
  },
  {
    q: "What is the difference between the licenses?",
    a: "The €30 monthly license gives you one month of access and renews until cancelled. The €165 lifetime license is a one-time payment for a perpetual right to use the purchased product, subject to its license terms.",
  },
  {
    q: "What happens after payment?",
    a: "Save your payment receipt and send it to us in Discord together with your order reference. After verification, you receive digital access to your selected models and tools.",
  },
  {
    q: "Will I receive a physical product?",
    a: "No. Scythe Products is 100% digital software. Nothing physical is sold or shipped.",
  },
  {
    q: "What is Woofer?",
    a: "Woofer is a hardware ID utility that rewrites and masks your machine's unique system identifiers — motherboard serial, CPU and GPU IDs, MAC address, and disk signatures — so your PC presents a completely fresh hardware profile. Available as a €25 one-time purchase or a €60 lifetime license.",
  },
  {
    q: "How is Woofer delivered?",
    a: "The same way as our AI models: 100% digital. Order on this page, complete payment, then send your receipt and order reference in our Discord. After verification you receive your files and access.",
  },
  {
    q: "Is there a model for my game?",
    a: "Models are game-specific. Message us in Discord to confirm availability and requirements for your title before choosing a plan.",
  },
];

const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 px-6 border-b border-red-500/20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <p className="font-mono-x text-xs text-[#ff4655] uppercase tracking-widest mb-1">Questions &amp; Answers</p>
          <h2 className="font-display text-4xl uppercase text-white">FAQ</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="p-5 bg-zinc-900/50 border border-zinc-800"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-bold text-white uppercase text-xs hover:text-[#ff4655] hover:no-underline text-left"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-xs leading-relaxed pt-2">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
